import React, { useEffect } from "react";
import {RunnerUpHeader } from "../../../ui";
import SelectField from "../../../library/components/Select";
import { useState } from "react";
import {   useGetErollFinalizationStatusDeoReportsMutation,
} from "../../../services/reportsServices";
import pdfIcon from "../../../images/pdfIcon.png"
import excelIcon from "../../../images/excelIcon.png"
import Table from "../../../ui/datatable/DataTable";
import { downloadExcelFile, downloadPdfFile } from "../../utilities/utils"
import LeftMenu from "../../AnalyticsModule/Left";
import RunnerUpHeaderNew from "../../../ui/runnerUpHeader/RunnerUpHeaderNew";

const ErollFinalizationStatusDeoReport = () => {
  const [totalNoOfRecords, setTotalNoOfRecords] = useState()
  const [state,setState]=useState();
  const [district,setDistrict]=useState();
  const [tabledata, setTabledata] = useState([]);
  const reportName = "e-Roll Finalization Status Report"
  const SheetName = "e-Roll Finalization report"
  const tableHeader = [];
  const columns = [
    {
      Header: "State Name",
      accessor: "col1",
    },
    {
      Header: "AC No. and Name",
      accessor: "col2",
    },
    {
      Header: "PC No. and Name",
      accessor: "col3",
    },
    {
      Header: "Eroll Finalization Status",
      accessor: "col4",
    },
    {
      Header: "Service Voter Count",
      accessor: "col5",
    },
   
  ];
  columns.map((item) => {
    tableHeader.push(item.Header)
  })
  const [erollFinalizaton,datac] =useGetErollFinalizationStatusDeoReportsMutation();
  useEffect(()=>{
  erollFinalizaton({constType:"AC"})
  .unwrap()
  .then((res) => {

    let tableData = []
    res?.payload?.map((item) => {
      tableData.push({
        "col1": item.stateName,
        "col2": `${item.acNo} - ${item.acName}`,
        "col3": `${item.pcNo} - ${item.pcName}`,
        "col4": item.erollFinalisedStatus==="Y"?"Yes":"No",
        "col5": item.serviceVoterCount,
      });
    });
    setState(res?.state)
    setDistrict(res?.district)
    setTabledata(tableData);
    setTotalNoOfRecords(res?.payload?.length)
  }).catch((error) => {
    if (error?.data?.message === "No record found") {
      setTabledata([])
    }
  })
},[])


  return (
    <LeftMenu>
    <div className="container box shadow ">
      <RunnerUpHeaderNew title={reportName} 
         state={ <span
                      
                    >
                      State: {state}{" "}
                      <span style={{ marginLeft: "13px" }}></span>District :{" "}
                      {district}
                      </span>}
        onPdfClick={() => downloadPdfFile(reportName, tableHeader, tabledata)} 
        onExcelClick={() => downloadExcelFile(reportName, SheetName, tableHeader, tabledata)} 
         />
      <div>
        <Table
          placeholder="Search"
          globalsearch={true}
          selectall={true}
          columns={columns}
          emptyMessage="No Record Found"
          data={tabledata?.length === 0 ? [] : tabledata}
          size={5}
          tableClassNameCheck="contenttable-eroll"
          records
          pagination
          gotopage
          rows
          numberrows={totalNoOfRecords}
        />
      </div>
    </div>
   </LeftMenu>
  );
};
export default ErollFinalizationStatusDeoReport;
